// 504 스타일 - 배경이미지 레이아웃 / 지역선택 버튼 + 이름·연락처 폼 / 청록 배경
// 01.jpg를 background-image로 사용, 지역선택 박스가 이미지 위에 오버레이

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleFormSubmit } from "../handlers/formHandlers";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { prohibitedWords } from "../utils/dummyData";

import "./randingStyle32.scss";
import PrivacyContent from "./PrivacyContent";
import RandingConsent from "./RandingConsent";

function RandingStyle32({
  urlCode,
  urlCodeSettingId,
  imageFolderPath,
  postBTN,
  companyName,
  apiUrl,
  kakaotalk,
  carrotTag,
  imageExtension = "jpg",
  imageAltTexts,
  themeColor = "#009493",
  mobileBottomBgColor,
  mobileContentPadding,
  areaQuestion = "현재 거주하시는 지역을 선택해주세요.",
  areaOptions = [],
  serviceInfoText,
  privacyCompanyName,
  privacyDetailContent,
}) {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState({
    first: "010",
    second: "",
    third: "",
  });
  const [isAgreed, setIsAgreed] = useState(false);
  const [isMarketingAgreed, setIsMarketingAgreed] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedEventId, setSelectedEventId] = useState(null);

  const validateInput = () =>
    validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber);

  const handleSubmit = () => {
    if (areaOptions.length > 0 && !selectedOption) {
      alert("지역을 선택해주세요.");
      return;
    }
    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      selectedValue: selectedEventId || undefined,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,
      apiUrl,
      kakaotalk,
      carrotTag,
    });
  };

  const getImagePath = (imageNum) =>
    `${imageFolderPath}/${imageNum}.${imageExtension}`;

  const privacyName = privacyCompanyName || companyName || "수집주체명";

  return (
    <div
      className="form-container randing-style-32"
      style={{ "--theme-color": themeColor, ...(mobileBottomBgColor && { "--mobile-bottom-bg": mobileBottomBgColor }), ...(mobileContentPadding && { "--mobile-content-padding": mobileContentPadding }) }}
    >
      {/* 배경이미지 섹션 - 01.jpg를 background-image로 */}
      <div
        className="rs32-bg-image"
        style={{ backgroundImage: `url(${getImagePath("01")})` }}
        role="img"
        aria-label={imageAltTexts?.header || "헤더 이미지"}
      >
        <div className="rs32-content-wrapper">
          {/* 지역 선택 박스 - 이미지 위에 오버레이 */}
          {areaOptions.length > 0 && (
            <div className="rs32-area-question-box">
              <div className="rs32-title-box">
                <span>01</span>
                <h3>{areaQuestion}</h3>
              </div>
              <div className="rs32-area-options">
                {areaOptions.map((opt) => (
                  <button
                    key={opt.value}
                    type="button"
                    className={`rs32-option-btn${selectedOption === opt.label ? " active" : ""}`}
                    onClick={() => {
                      setSelectedOption(opt.label);
                      window._selectedOption = opt.label;
                      if (opt.eventId) {
                        // events_option_uuid 전환: uuid 문자열이므로 숫자 변환 금지
                        const eid = opt.eventId;
                        setSelectedEventId(eid);
                        window._selectedEventId = eid;
                      }
                    }}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* 하단 섹션 - 폼 + 개인정보 + 버튼 */}
      <div className="rs32-bottom-wrapper">
        {/* 폼 */}
        <form
          className="rs32-dentevent-form"
          id="dentevent-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div className="rs32-input-wrap">
            <div className="rs32-input-user">
              <label htmlFor="rs32-name">이름</label>
              <input
                type="text"
                id="rs32-name"
                placeholder="입력*"
                required
                maxLength="10"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="rs32-input-contact">
              <label>연락처</label>
              <div className="rs32-phone-wrap">
                <input
                  type="tel"
                  name="first"
                  maxLength="3"
                  placeholder="010"
                  required
                  readOnly
                  value="010"
                />
                <input
                  type="tel"
                  name="second"
                  maxLength="4"
                  placeholder="입력*"
                  required
                  value={phoneNumber.second}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    setPhoneNumber((prev) => ({ ...prev, second: value }));
                    if (value.length >= 4) {
                      e.target.nextElementSibling?.focus();
                    }
                  }}
                />
                <input
                  type="tel"
                  name="third"
                  maxLength="4"
                  placeholder="입력*"
                  required
                  value={phoneNumber.third}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    setPhoneNumber((prev) => ({ ...prev, third: value }));
                  }}
                />
              </div>
            </div>
          </div>
        </form>

        {/* 개인정보 동의 */}
        <RandingConsent
          isAgreed={isAgreed}
          setIsAgreed={setIsAgreed}
          isMarketingAgreed={isMarketingAgreed}
          setIsMarketingAgreed={setIsMarketingAgreed}
          companyName={privacyName}
          privacyContent={
            privacyDetailContent || <PrivacyContent companyName={privacyName} />
          }
        />

        {/* 서비스 안내 */}
        {serviceInfoText && (
          <div className="rs32-service-info">
            <p>{serviceInfoText}</p>
          </div>
        )}

        {/* 신청하기 버튼 */}
        <button
          type="submit"
          form="dentevent-form"
          className="rs32-btn-apply"
          disabled={isSubmitting}
        >
          <img src={postBTN} alt="신청하기" />
        </button>
      </div>
    </div>
  );
}

export default RandingStyle32;
